module.exports = __webpack_public_path__ + "static/media/mood.612a7ebb.jpg";